export const booleanFormater  = (params:any) =>{
    return (params.value === true) ? 'Sim' : 'Não';
}